import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsStar = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="m5.825 21 1.625-7.025L2 9.25l7.2-.625L12 2l2.8 6.625 7.2.625-5.45 4.725L18.175 21 12 17.275z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsStar);
const Memo = memo(ForwardRef);
export default Memo;
